import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../store/slices/UI";
import Button from "../../../../UI/GeneralPurpose/Button";

const UIText = {
  "es-CL": { label: "Cancelar" },
  "en-US": { label: "Cancel" },
};

const Cancel = () => {
  const { dispatch, UI } = useUIBp();
  const open = UI["group-traveler2-open"] ?? false;

  const onClick = () => {
    dispatch(UIactions.closeModal());
  };

  return <Button {...{ disabled: open, UIText, onMouseUp: onClick, variant:'text' }} />;
};

export default Cancel;
